import { Chip as DigChip } from "@dropbox/dig-components/chip";
import { Text } from "@dropbox/dig-components/typography";
import styled from "@emotion/styled";
import React from "react";

export type Props = {
  startIcon?: React.ReactNode;
  label?: React.ReactNode;
  selected?: boolean;
  active?: boolean;
  onSelect?: () => void;
  disabled?: boolean;
};

/**
 * Filter chips made in house. The DIG version of Chips
 * has been deprecated.
 */
export function Chip({
  startIcon,
  label,
  selected = false,
  active = false,
  onSelect,
  disabled = false,
}: Props) {
  return (
    <ChipContainer
      isSelected={selected}
      selectedStyle="stroke"
      active={active}
      onClick={onSelect}
      iconOnly={!!(startIcon && !label)}
      disabled={disabled}
    >
      <ChipLabel>
        {startIcon}
        {label && <Text>{label}</Text>}
      </ChipLabel>
    </ChipContainer>
  );
}

const ChipContainer = styled(DigChip, {
  shouldForwardProp(propName) {
    return !["active", "iconOnly"].includes(propName);
  },
})<{
  active?: boolean;
  iconOnly?: boolean;
}>`
  display: flex;
  align-items: center;
  padding: ${({ iconOnly }) => (iconOnly ? "5px 5px" : "5px 10px")};
  border-radius: 16px;

  ${({ active }) => {
    if (active) {
      return `
        background-color: var(--dig-color__opacity__surface--state-2);
        &:hover {
          background-color: var(--dig-color__opacity__surface--state-2);
        }
      `;
    }
  }}
`;

const ChipLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;
